import { combineReducers } from "redux";

import adminSession from "./adminSession";
import assessmentSession from "./assessmentSession";
import botpressSession from "./botpressSession";
import creatorSession from "./creatorSession";
import nmhaSession from "./nmhaSession";
import onboardingSession from "./onboardingSession";
import partnerSession from "./partnerSession";
import patientSession from "./patientSession";
import practiceSession from "./practiceSession";
import providerSession from "./providerSession";
import searchSession from "./searchSession";
import trialSession from "./trialSession";
import userSession from "./userSession";

export default combineReducers({
  onboardingSession,
  userSession,
  patientSession,
  adminSession,
  trialSession,
  practiceSession,
  assessmentSession,
  partnerSession,
  providerSession,
  nmhaSession,
  creatorSession,
  searchSession,
  botpressSession,
});
